// extracted by mini-css-extract-plugin
export default {"container":"jr-z","heading":"kr-z","text":"lr-z","info":"mr-z","link":"nr-z","fullMaxWidth":"or-z"};